import React from 'react'

import { BaseBatchTransactions } from './BaseBatchTransactions'

interface Props {}

export function CaptureTransactions (_props: Props) {
  return (
    <BaseBatchTransactions
      searchType='capturable'
      action='capture'
      helpLink='https://paytrace.atlassian.net/wiki/spaces/HD/pages/2025783819/Capture+Transactions'
      title='Capture Transactions'
    />
  )
}

export default CaptureTransactions
